<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center">
    <div class="auth-box">
      <div class="logo">
        <span class="db"><img src="@/assets/img/logo-icon.png" class="mb-3" alt="logo" style="width: 45px;" /></span>
        <h5 class="font-medium">{{ $t('apps.app_name') }}</h5>
        <p>{{ $t('auth.sign_in_as') }} <span class="text-primary">{{ $t('global.admin') }}</span></p>
      </div>
      <form class="form-horizontal m-t-20" @submit.prevent="handleSubmit">
        <div class="input-group mb-3">
          <div class="input-group-prepend"><span class="input-group-text"><i class="ti-user"></i></span></div>
          <input v-model.trim="form.email" type="email" class="form-control form-control-lg" :placeholder="$t('auth.username_or_email')" required>
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend"><span class="input-group-text"><i class="ti-pencil"></i></span></div>
          <input v-model="form.password" type="password" class="form-control form-control-lg" :placeholder="$t('auth.password')" required>
        </div>
        <div class="form-group text-center">
          <button class="btn btn-block btn-lg btn-primary" :disabled="isLoading">
            <span v-if="isLoading" class="spinner-border spinner" role="status"></span>
            <span>{{ $t('auth.sign_in') }}</span>
          </button>
        </div>
        <div class="form-group text-center">
          <router-link to="/register" class="btn btn-block btn-lg btn-outline-primary">Daftar</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      form: { email: '', password: '' },
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    async handleSubmit() {
      this.isLoading = true
      try {
        await this.login(this.form)
        const redirect = this.$route.query.redirect || '/dashboard'
        await this.$router.push(redirect)
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Login gagal')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.spinner { height: 1rem !important; width: 1rem !important; }
</style>
